import {Component} from "@angular/core";
import {NavigationService} from "../../orchestration/navigation.service";
import {ButtonConnotation, ButtonProminence, ButtonTier} from "../../buttons/button/button";
import {Page} from "../../orchestration/page";
import {NavigationParams} from "../../orchestration/navigation-params";

export class ButtonSpec {
    label: string;
    connotation: ButtonConnotation;
    result?: any;
}

export class CheckboxSpec {
    label: string;
    name: string;
    checked: boolean;
}

@Component({
    selector: "woa-simple-dialog-page",
    templateUrl: "simple-dialog-page.component.html",
    providers: [{provide: Page, useExisting: SimpleDialogPageComponent}]
})
export class SimpleDialogPageComponent extends Page {
    ButtonTier = ButtonTier;
    ButtonProminence = ButtonProminence;
    ButtonConnotation = ButtonConnotation;

    showHeader: boolean;
    showCloseButton: boolean;
    title: string;
    subtitle: string;
    translationParams: any;
    contentText: string;
    popHistoryOnDismissal: boolean;
    buttons: ButtonSpec[];
    checkboxes: CheckboxSpec[];

    checkboxState: { [name: string]: boolean } = {};

    constructor(navigationParams: NavigationParams,
                private navigationService: NavigationService) {
        super();
        this.showHeader = navigationParams.get("showHeader");
        if (this.showHeader === undefined) {
            this.showHeader = true;
        }
        this.showCloseButton = navigationParams.get("showCloseButton");
        if (this.showCloseButton === undefined) {
            this.showCloseButton = true;
        }
        this.title = navigationParams.get("title");
        this.subtitle = navigationParams.get("subtitle");
        this.translationParams = navigationParams.get("translationParams");
        this.contentText = navigationParams.get("contentText");
        this.popHistoryOnDismissal = navigationParams.get("popHistoryOnDismissal");
        if (this.popHistoryOnDismissal === undefined) {
            this.popHistoryOnDismissal = true;
        }
        this.buttons = navigationParams.get("buttons") || [];
        this.checkboxes = navigationParams.get("checkboxes") || [];
        this.checkboxes.forEach((checkbox: CheckboxSpec) => this.checkboxState[checkbox.name] = checkbox.checked || false);
    }

    async dismiss(result?: any): Promise<any> {
        this.checkboxes.forEach((checkbox: CheckboxSpec) => checkbox.checked = this.checkboxState[checkbox.name]);
        return this.navigationService.dismissPage(this, typeof result === "function" ? result(this.checkboxState) : result, false, this.popHistoryOnDismissal);
    }
}



// WEBPACK FOOTER //
// ./src/app/notification/simple-dialog-page/simple-dialog-page.component.ts